<form>
  <div class="a7-ui-auth-form-title a7-ui-auth-form_section text-center">
    <h2>{{formTitle}}</h2>
    <ng-content select="[a7-auth-form-title]"></ng-content>
  </div>

  <div class="info-section a7-ui-auth-form_section v2-margin-40px-t">
    <ng-content select="[a7-auth-form-body]"></ng-content>
    <ng-content></ng-content>
  </div>

  <div class="action-section a7-ui-auth-form_section full-width v2-margin-40px-t"
       fxLayout="row wrap"
       fxLayoutAlign="center center">
    <ng-content select="[a7-auth-form-actions]"></ng-content>
  </div>

  <div class="bottom-section a7-ui-auth-form_section v2-margin-2-t">
    <ng-content select="[a7-auth-form-bottom]"></ng-content>
  </div>
</form>
